var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 65.619,
    viewBox: "0 0 100 65.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4527",
    width: 100,
    height: 65.619,
    transform: "translate(0 0)",
    fill: "#929ea7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "id\\xE9z\\u0151jel",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16090",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10387",
    d: "M97.6,65.621s8.224-10.8,8.995-18.714C81.437,41.745,81.138,5.34,106.621.6c16.787-3.863,28.48,12,27.593,23.041,0,23.958-26.678,40.166-36.614,41.981",
    transform: "translate(-34.261 -0.002)",
    fill: "#929ea7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10388",
    d: "M46.6,23.637C47.479,12.6,35.794-3.281,19,.6-6.483,5.343-6.176,41.746,18.976,46.9c-.771,7.914-8.995,18.714-8.995,18.714C19.919,63.8,46.6,47.6,46.6,23.637",
    transform: "translate(0 0)",
    fill: "#929ea7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.8b73514ab8dd8dde440bc054a894164c.svg";
export { ForwardRef as ReactComponent };